module.exports = __webpack_public_path__ + "img/Voyante.2c1e1e4d.png";